import { FC } from "react";
import { useBottomLineRating } from "@wff/hooks/yotpo/useBottomLineRating";
import classes from "./StarRating.module.scss";

interface StarProps {
  marked: boolean;
  starId: number;
  readonly?: boolean;
  size?: string;
  color?: string;
}

const Star = ({ marked, starId, readonly, size, color }: StarProps) => {
  return (
    <span
      data-star-id={starId}
      className={classes.star}
      style={{
        fontSize: size,
        cursor: readonly ? "default" : "pointer",
        color: color,
      }}
      role="button"
    >
      {marked ? "\u2605" : "\u2606"}
    </span>
  );
};

Star.defaultProps = {
  readonly: true,
  size: "1.5rem",
  color: "#d14124",
};

interface StarRatingProps {
  size?: string;
  color?: string;
  readonly?: boolean;
  productId: string;
  reviewRef?: React.MutableRefObject<HTMLDivElement | null>;
}

export const StarRating: FC<StarRatingProps> = ({
  readonly,
  size,
  color,
  productId,
  reviewRef,
}) => {
  const handleOnClick = () => {
    const elem = reviewRef?.current;
    if (elem) {
      const reviews = elem.getBoundingClientRect();
      const offset = reviews.top - 250;
      window.scrollTo({ top: window.scrollY + offset, behavior: "smooth" });
    }
  };
  const bottomLineRating = useBottomLineRating(productId);

  if (
    !bottomLineRating ||
    bottomLineRating.status !== "fulfilled" ||
    !bottomLineRating.data
  ) {
    return null;
  }

  const ratings = bottomLineRating.data.bottomline;

  return (
    <div onClick={handleOnClick}>
      {Array.from({ length: 5 }, (_, i) => (
        <Star
          size={size}
          color={color}
          readonly={readonly}
          starId={i + 1}
          key={`star_${i + 1}`}
          marked={ratings.average_score >= i + 1}
        />
      ))}
      <span
        className={classes["total-reviews"]}
      >{`(${ratings.total_reviews})`}</span>
    </div>
  );
};

StarRating.defaultProps = {
  size: "1.5rem",
  color: "#d14124",
  readonly: true,
};
